//vertical trimming labor surcharge

export function calculateD9(finishedLength, COM, panelOrPair) {
      console.log('calculateD9() start');
      console.log('- ',finishedLength, COM, panelOrPair);
      var x;

      if (panelOrPair == 'Panel') {
            x = 1;
      } else if (panelOrPair == 'Pair') {
            x = 2;
      }

      if (COM == true) {
            if (finishedLength <= 36) {
                  return 49 * x;
            } else if (finishedLength > 36 && finishedLength <= 48) {
                  return 74 * x;
            } else if (finishedLength > 48 && finishedLength <= 60) {
                  return 86 * x;
            } else if (finishedLength > 60 && finishedLength <= 72) {
                  return 98 * x;
            } else if (finishedLength > 72 && finishedLength <= 84) {
                  return 123 * x;
            } else if (finishedLength > 84 && finishedLength <= 96) {
                  return 135 * x;
            } else if (finishedLength > 96 && finishedLength <= 108) {
                  return 147 * x;
            } else if (finishedLength > 108) {
                  let extra = Math.ceil((finishedLength - 108) / 12) * 25;
                  return (extra + 72) * x;
            }
      } else if (COM == false) {
            if (finishedLength <= 36) {
                  return 43 * x;
            } else if (finishedLength > 36 && finishedLength <= 48) {
                  return 64 * x;
            } else if (finishedLength > 48 && finishedLength <= 60) {
                  return 75 * x;
            } else if (finishedLength > 60 && finishedLength <= 72) {
                  return 85 * x;
            } else if (finishedLength > 72 && finishedLength <= 84) {
                  return 107 * x;
            } else if (finishedLength > 84 && finishedLength <= 96) {
                  return 117 * x;
            } else if (finishedLength > 96 && finishedLength <= 108) {
                  return 128 * x;
            } else if (finishedLength > 108) {
                  let extra = Math.ceil((finishedLength - 108) / 12) * 21;
                  return (extra + 72) * x;
            }
      } else {
            console.log('- COM is null');
      }
}
